import { Inbox } from "lucide-react";

interface Props {
  text?: string;
}

export function NoData({ text = "We couldn’t find anything that matches your search" }: Props) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      <div className="flex flex-col items-center justify-center py-10 text-center text-muted-foreground space-y-4">
        <div className="flex items-center justify-center border border-muted-foreground rounded-full p-4">
          <Inbox className="w-8 h-8" strokeWidth={1} />
        </div>
        <div className="flex flex-col">
          <span className="text-md text-foreground">No Results Found</span>
          <span className="text-sm">{text}</span>
        </div>
      </div>
    </div>
  );
}
